import { render } from "./AppFooter.vue?vue&type=template&id=9ec77b9e&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=9ec77b9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec77b9e"]])

export default __exports__